import React from "react";
import IconButton from "components/IconButton";
import Button from "components/Button";
import { useActions } from "state/hooks";
import { loginSocial } from "state/actions/auth";
import Icon from "components/Icon";
//import PropTypes from 'prop-types';

export default function SocialLogin(props) {
    const { onLogin } = useActions({
        onLogin: loginSocial,
    });

    return (
        <div className={"rows gap-xs rows-center"}>
            <div className={"type-sm o-50"}>
                or continue with social profile
            </div>
            <div className={"cols cols-center gap-xs"}>
                {/*<IconButton onClick={()=>onLogin('github')} icon={'github'}/>*/}
                <Button
                    variant={"outlined"}
                    onClick={() => onLogin("google-oauth2")}
                    startIcon={<Icon>google</Icon>}
                >
                    Google
                </Button>
                <Button
                    variant={"outlined"}
                    onClick={() => onLogin("github")}
                    startIcon={<Icon>github</Icon>}
                >
                    Github
                </Button>
            </div>
        </div>
    );
}

SocialLogin.propTypes = {};
SocialLogin.defaultProps = {};
